/**
 * O ENDEREÇO DO AVISO na mesa. A rota do aviso (`org.aviso.rota`) é texto do
 * banco e pode trazer a busca — a divergência de horas (0091) leva ao dia dela
 * na fila (`/operacao/conciliacao?de=…&ate=…&situacao=aberta`), e o pedido
 * atrasado ao pedido (`/compras?pedido=…`).
 *
 * O roteador NÃO lê a busca de dentro do `to`: `/x?y=1` vira um caminho que
 * não existe. Por isso o caminho e a busca são separados aqui, e o link leva
 * os dois pelo lugar certo.
 */
export function enderecoDoAviso(rota: string): { readonly to: string; readonly search: Readonly<Record<string, string>> } {
  const semAncora = rota.split('#')[0] ?? '';
  const marca = semAncora.indexOf('?');
  const caminho = marca === -1 ? semAncora : semAncora.slice(0, marca);
  const consulta = marca === -1 ? '' : semAncora.slice(marca + 1);
  return {
    to: caminho === '' ? '/' : caminho,
    search: Object.fromEntries(new URLSearchParams(consulta)),
  };
}
